import { CommandBar, IStackProps, IStackStyles, Label, Link, Text } from '@fluentui/react';

export const PortalPageTitleText = styled(Text)`
  color: #000;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
`;

export const PortalPageSubtitleText = styled.p`
  color: #323130;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif;
  margin-top: 8px;
  margin-bottom: 0;
`;

export const PortalPageHeadingSection = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  padding: 30px 100px;
  background: #f2f9ff;
  flex-shrink: 1;

  @media (max-width: 1024px) {
    padding: 16px 40px;
  }
`;

export const ButtonsTableSection = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  padding-left: 100px;
  padding-right: 100px;
  overflow-x: auto;
  overflow-y: auto;
  max-width: calc(100vw - 48px);
  flex: 1;
  min-height: 0;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const PortalPageCommandBar = styled(CommandBar)`
  display: flex;
  padding-top: 30px;
  padding-bottom: 8px;
  margin-left: -24px;
`;

export const PlainCommandBar = styled(CommandBar)`
  display: flex;
  backgroundColor: '#fafafa' //grey
`;

export const PortalPagePanelText = styled(Text)`
  font-weight: 700;
  font-size: 26px;
  line-height: 32px;
  color: #171717;
  padding-left: 48px;
`;

export const ServiceTreeSectionLoading = styled.div`
  display: flex;
  height: 128px;
  justify-content: center;
`;

export const PortalPageLink = styled(Link)`
  font-size: 14px;
  line-height: 20px;
`;

export const PortalPagePanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
`;

export const GroupBoxComponent = styled.div`
  background: #fafafa; //grey
  border: 1px solid #000000;
  box-sizing: border-box;
  padding: 5%;
`;

export const BoxComponent = styled.div`
  background: #fafafa; //grey
  border: 1px solid #000000;
`;

export const TableComponent = styled.table`
  padding-left: 3%;
  padding-right: 3%;
  padding-bottom: 3%;
`;

export const OuterBoxComponent = styled.div`
  border: 1px solid #000000;
  box-sizing: border-box;
  padding: 2%;
`;

export const StackTokens = { childrenGap: 50 };
export const StackStyles: Partial<IStackStyles> = { root: { width: 650 } };
export const ColumnProps: Partial<IStackProps> = {
  tokens: { childrenGap: 15 },
  styles: { root: { width: 300 } },
};

export const SingleRowContainer = styled.div`
  display: flex;
`;

export const CompactPortalCommandBar = styled(CommandBar)`
  display: flex;
  padding-top: 5px;
  padding-bottom: 8px;
  margin-left: -24px;
`;

export const SubscriberPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  width: 100%;
  height: calc(100vh - 48px);
  overflow: hidden;
`;

export const SubscriberPageHeadingSection = styled(PortalPageHeadingSection)`
  width: 100%;
`;

export const SubscriberButtonsTableSection = styled(ButtonsTableSection)`
  width: 100%;
  flex: 1;
  min-height: 0;
`;

export const SubscriberTableScrollWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: auto;
  padding: 0;
  box-sizing: border-box;
`;

export const SubscriberTableContentWrapper = styled.div`
  min-width: 1400px;
  width: max-content;
`;

export const SubscriberTableViewport = styled.div`
  padding-bottom: 20px;
`;

export const InlineTooltipWrapper = styled.div`
  display: inline-block;
`;

export const DialogTitleLabel = styled(Label)`
  font-size: 16px;
`;

export const DialogBodyText = styled(Text)`
  font-size: 12px;
  padding-top: 15px;
`;
